import * as React from 'react';
import { SxProps, Theme, Tooltip as MatTooltip } from '@mui/material';
// disabling no unsed, in order to extract the disabled prop so it is
// not passed down to the tooltip.
/* eslint-disable @typescript-eslint/no-unused-vars */

type Placement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

export interface TooltipProps {
  disableFocusListener?: boolean;
  disableHoverListener?: boolean;
  interactive?: boolean;
  placement?: Placement;
  title: string;
  children: React.ReactElement;
  disabled?: boolean;
  className?: string;
  onClose?: any;
  onOpen?: any;
  open?: any;
  sx?: SxProps<Theme>;
}

const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(({ disabled, ...rest }, ref) => {
  return <MatTooltip {...rest} ref={ref} />;
});

Tooltip.displayName = 'Tooltip';

export { Tooltip };
